import { AnyAction } from 'redux';
import {
    RESET_STATE,
    GROUPS_COUNT,
    GET_PEOPLE_COUNT_IN_GROUP,
    GET_GROUPS_COUNT_IN_GROUP,
    GET_APPLICATIONS_IN_GROUP,
    GET_VAULTS_IN_GROUP,
    GET_GROUP,
    GET_ALL_GROUPS,
    GET_GROUPS_MEMBER_COUNT,
    GET_GROUPS_VAULT_COUNT,
    GET_GROUPS_APPLICATION_COUNT,
    GROUPS_LOADING,
    GET_GROUPS_AGENT_DETAIL,
    GET_GROUPS_DTO,
    GET_USERS_TO_GROUPS,
    GET_GROUPS_TO_GROUPS,
    GROUPS_FOR_SELECT,
    GET_GROUPS_IN_GROUP_COUNT,
    GET_USERS_IN_GROUP_COUNT
} from '@app/store/constants';

const initialState = {
    group: {},
    groups: [],
    count: 0,
    groupsDTO: [],
    groupMemberCount: [],
    groupUsersCount: [],
    groupGroupsCount: [],
    groupVaultCount: [],
    groupApplicationCount: [],
    groupAgentDetail: null,
    vaultsInGroup: [],
    applicationsInGroup: [],
    groupsLoading: true,
    groupsInGroupCount: 0,
    peopleInGroupCount: 0,
    usersToGroups: {},
    groupsToGroups: {},
    groupsForSelect: []
};

export function groups(state = initialState, action: AnyAction) {
    const { payload, type } = action;

    switch (type) {
        case RESET_STATE:
            return initialState;
        case GET_ALL_GROUPS:
            return {
                ...state,
                groups: payload
            };
        case GET_GROUPS_MEMBER_COUNT:
            return {
                ...state,
                groupMemberCount: payload
            };
        case GET_USERS_IN_GROUP_COUNT:
            return {
                ...state,
                groupUsersCount: payload
            };
        case GET_GROUPS_IN_GROUP_COUNT:
            return {
                ...state,
                groupGroupsCount: payload
            };
        case GET_GROUPS_VAULT_COUNT:
            return {
                ...state,
                groupVaultCount: payload
            };
        case GET_GROUPS_APPLICATION_COUNT:
            return {
                ...state,
                groupApplicationCount: payload
            };
        case GET_GROUPS_AGENT_DETAIL:
            return {
                ...state,
                groupAgentDetail: payload
            };
        case GROUPS_LOADING:
            return {
                ...state,
                groupsLoading: payload
            };
        case GET_GROUPS_DTO:
            return {
                ...state,
                groupsDTO: payload
            };
        case GET_GROUP:
            return {
                ...state,
                group: payload
            };
        case GET_APPLICATIONS_IN_GROUP:
            return {
                ...state,
                applicationsInGroup: payload
            };
        case GET_VAULTS_IN_GROUP:
            return {
                ...state,
                vaultsInGroup: payload
            };
        case GET_PEOPLE_COUNT_IN_GROUP:
            return {
                ...state,
                peopleInGroupCount: payload
            };
        case GET_GROUPS_COUNT_IN_GROUP:
            return {
                ...state,
                groupsInGroupCount: payload
            };
        case GROUPS_COUNT:
            return {
                ...state,
                count: payload
            };
        case GET_USERS_TO_GROUPS:
            return {
                ...state,
                usersToGroups: payload
            };
        case GET_GROUPS_TO_GROUPS:
            return {
                ...state,
                groupsToGroups: payload
            };
        case GROUPS_FOR_SELECT:
            return {
                ...state,
                groupsForSelect: payload
            };
        default:
            return state;
    }
}
